/**
 * Copyright 2020-present, TIENDUC.
 * All rights reserved.
 * @author ductt24@ghtk.vn on 10/08/2020.
 * @module Printer
 * @description Printer Routing
 */

import React, { lazy, memo } from "react";

const PrinterDashboardPage = lazy(() => import("./pages/dashboard"));
const PrinterMangePage = lazy(() => import("./pages/manage"));
const PrinterSurveyPage = lazy(() => import("./pages/survey"));
const PrinterLanMangePage = lazy(() => import("./pages/printer-lan"));
const PrinterBluetoothManagePage = lazy(() => import("./pages/printer-bluetooth"));
const PrinterBluetoothSurveyPage = lazy(() => import("./pages/survey-bluetooth"));
const PrinterLanSurveyPage = lazy(() => import("./pages/survey-lan"));

const PrinterRoutes = [
  { path: "printer-dashboard", element: <PrinterDashboardPage /> },
  { path: "printer-list", element: <PrinterMangePage /> },
  { path: "printer-lan", element: <PrinterLanMangePage /> },
  { path: "printer-bluetooth", element: <PrinterBluetoothManagePage /> },
  { path: "printer-survey", element: <PrinterSurveyPage /> },
  { path: "survey-bluetooth", element: <PrinterBluetoothSurveyPage /> },
  { path: "survey-lan", element: <PrinterLanSurveyPage /> },
];
export default PrinterRoutes;
